// @core/api/endpoints/chat/list_messages.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListMessagesResponse,
} from '../../../types/chat';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/chat';

/**
 * List messages in conversation
 * Returns a paginated list of messages using cursor-based pagination. Supports fetching messages before, after, or around a specific message ID.
 */
export async function ListMessages(
  conversation_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListMessagesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/messages`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  const requestOptions = options;
  return client.get<ListMessagesResponse>(requestPath, { ...requestOptions, params });
}
